<script setup lang = "ts">

import type {PropType} from "vue";
import type {User} from "~/models/services/User";

const emit = defineEmits(['contactClick'])

const props = defineProps({
	user_id: {type: Object as PropType<number | string>},
	hideContactButton: {type: Boolean, default: false},
})
const {showUser} = useUser()

const user = ref<User>()
const getIcon = (key: string) => {
	switch (key) {
		case 'facebook':
			return 'fa-brands fa-facebook-f'
		case 'instagram':
			return 'fa-brands fa-instagram'
		case 'x-twitter':
			return 'fa-brands fa-x-twitter'
		case 'linkedin':
			return 'fa-brands fa-linkedin-in'
		case 'website':
			return 'fa-solid fa-globe'
	}
}

onMounted(() => {
	showUser(props.user_id).then(response => {
		user.value = response.data
	})
})

const getProfilePicture = computed(() => {
	if (user.value) {
		if (user.value.agent) {
			return user.value.agent.profile_picture
		}
		return user.value.profile_picture
	}
	return null
})
const getLink = computed(() => {
	if (user.value) {
		if (user.value.agent) {
			return user.value.agent.link
		}
	}
	
	return null;
})
const getCompany = computed(() => {
	if (user.value) {
		if (user.value.agent) {
			return user.value.agent.business_name
		}
	}
	
	return 'Vendedor';
})
const getEmail = computed(() => {
	if (user.value) {
		if (user.value.agent) {
			return user.value.agent.email
		}
		return user.value.email
	}
	
	return null
})
const getPhone = computed(() => {
	if (user.value) {
		if (user.value.agent) {
			return user.value.agent.phone
		}
		return user.value.phone
	}
	
	return null
	
})

</script>

<template>
	<div class = "bg-gray-100 w-full rounded-2xl py-5 px-5 ">
		<div class = "flex flex-row items-center justify-between flex-nowrap">
			<div class = "flex flex-row flex-shrink items-center">
				<q-avatar :color = "!!getProfilePicture?'transparent':'primary'"
									text-color = "white"
									size = "80px"
									:icon = "!!getProfilePicture?undefined:'fa-solid fa-user'">
					<img v-if = "!!getProfilePicture"
							 :src = "`https://cdn.compralovendelo.com/${getProfilePicture}`">
				</q-avatar>
				<div class = "flex flex-col flex-nowrap ml-2 justify-center">
					<NuxtLink
							:class = "`${getLink?'cursor-pointer':''} text-lg text-wrap truncate overflow-hidden overflow-ellipsis mb-[-5px]`"
							:to = "getLink?'/agente/'+getLink:undefined"
							style = "display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical;">
						{{ getCompany }}
					</NuxtLink>
					<NuxtLink
							:class = "`${getLink?'cursor-pointer':''} text-lg font-light text-wrap truncate overflow-hidden overflow-ellipsis`"
							:to = "getLink?'/agente/'+getLink:undefined"
							style = "display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical;">
						{{ user?.name }}
					</NuxtLink>
					<div class = "flex flex-row">
						<template v-for = "(social) in user?.agent?.social_media">
							<a v-if = "!!social.url" :href = "social.url" class = "text-gray-600 mr-2 text-base" target = "_blank">
								<i :class = "getIcon(social.media??'')"/>
							</a>
						</template>
						<a v-if = "!user?.agent" :href = "`tel:${getPhone}`" class = "text-gray-600 mr-2 text-base"
							 target = "_blank">
							<i class = "fa-solid fa-phone"/>
						</a>
						<a v-if = "getEmail" :href = "`mailto:${getEmail}`" class = "text-gray-600 mr-2 text-base"
							 target = "_blank">
							<i class = "fa-solid fa-envelope"/>
						</a>
					</div>
				</div>
			</div>
		</div>
		<template v-if = "getLink">
			<q-separator class = "my-2"/>
			<div class = "flex flex-row gap-2">
				<q-btn v-if = "getLink" @click = "navigateTo(`/agente/${getLink!}`)"
							 outline
							 color = "gray-600"
							 class = "rounded-xl flex-grow"
							 padding = "5px 10px">
					<i class = "fa-solid fa-user mr-2"/> Ver Perfil
				</q-btn>
				<q-btn v-if = "getLink" @click = "navigateTo({path:`/agente/${getLink!}`,query:{position:'inventory'}})"
							 outline
							 color = "gray-600"
							 class = "rounded-xl flex-grow"
							 padding = "5px 10px">
					<i class = "fa-solid fa-car mr-2"/> Ver Inventario
				</q-btn>
				<q-btn v-if = "getPhone" @click = "navigateTo(`tel:${getPhone}`,{external:true})"
							 class = "rounded-xl"
							 color = "primary">
					<i class = "fa-solid fa-phone"/>
				</q-btn>
			</div>
		</template>
	</div>

</template>


<style scoped>

</style>
